import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { PeriodType } from '@shared/utils/utils';

import {
  BudgetCompareMenuPeriodFormControl,
  BudgetCompareMenuPeriodList,
  defaultPeriodList,
} from '../../models/budget-compare-menu.models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgSelectModule, ReactiveFormsModule],
  selector: 'aux-budget-compare-menu-period',
  templateUrl: './budget-compare-menu-period.component.html',
})
export class BudgetCompareMenuPeriodComponent {
  @Input() periodFormControl: BudgetCompareMenuPeriodFormControl;
  @Input() periodList: BudgetCompareMenuPeriodList;

  constructor() {
    this.periodFormControl = new FormControl<string>(PeriodType.PERIOD_MONTH, {
      nonNullable: true,
    });
    this.periodList = defaultPeriodList;
  }
}
